import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_EXCHANGES_SUCCESS":
    case "GET_EXCHANGES_FAILURE":
      return false;

    case "GET_EXCHANGES_REQUEST":
      return true;

    default:
      return state;
  }
}
